import { USERS_TYPE } from '@/utils/constants';

export function isRoleCandidate(role) {
  return role === USERS_TYPE.candidate
}